import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return ($props.position)
    ? (_openBlock(), _createBlock(_component_GMapMap, {
        key: 0,
        zoom: 13,
        center: $props.position,
        "map-type-id": "terrain",
        "disable-default-ui": "true",
        options: $setup.mapOptions,
        style: {"width":"100% height: 100%"},
        ref: "map"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_GMapMarker, {
            position: $props.position,
            clickable: true,
            draggable: true,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.center = _ctx.m.position)),
            icon: $setup.icon
          }, null, 8, ["position", "icon"])
        ]),
        _: 1
      }, 8, ["center"]))
    : _createCommentVNode("", true)
}